// extracted by mini-css-extract-plugin
export default {"label":"style_label__rRxfx","amount":"style_amount__ZuaCy"};